/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";

import Card from "@mui/material/Card";
import { formatDate, formatCurrency } from "utils";
import SoftBox from "components/SoftBox";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import DataTable from "./DataTable";
import ActionCell from "./components/ActionCell/index";
import { SecuritiesPortfolioService } from "services/securities-portfolio";

const renderData = (items, setDataTable) => {
  return items.map((item) => {
    const totalBoughtQty =
      item.items?.reduce((sum, it) => sum + (parseFloat(it.bought?.quantity) || 0), 0) || 0;
    const totalSoldQty =
      item.items?.reduce((sum, it) => sum + (parseFloat(it.sold?.quantity) || 0), 0) || 0;
    const totalBoughtAmount = formatCurrency.format(
      item.items?.reduce((sum, it) => sum + (parseFloat(it.bought?.amount) || 0), 0) || 0
    );
    const totalSoldAmount = formatCurrency.format(
      item.items?.reduce((sum, it) => sum + (parseFloat(it.sold?.amount) || 0), 0) || 0
    );

    return {
      id: item._id,
      account: item.account || "N/A",
      securityType: item.securityType || "N/A",
      company: item.company?.name || "N/A",
      totalBoughtQty,
      totalSoldQty,
      totalBoughtAmount,
      totalSoldAmount,
      createdAt: formatDate(item.createdAt),
      action: <ActionCell item={item} setDataTable={setDataTable} />,
    };
  });
};

const tableData = {
  columns: [
    {
      Header: "Tài khoản",
      accessor: "account",
      width: "12%",
    },
    {
      Header: "Loại CK",
      accessor: "securityType",
      width: "15%",
    },
    {
      Header: "Tổng mua (SL)",
      accessor: "totalBoughtQty",
      width: "12%",
    },
    {
      Header: "Tổng bán (SL)",
      accessor: "totalSoldQty",
      width: "12%",
    },
    {
      Header: "Tổng mua (TT)",
      accessor: "totalBoughtAmount",
      width: "15%",
    },
    {
      Header: "Tổng bán (TT)",
      accessor: "totalSoldAmount",
      width: "15%",
    },
    {
      Header: "Ngày tạo",
      accessor: "createdAt",
      width: "12%",
    },
    { Header: "Thao tác", accessor: "action", sorted: false },
  ],
  rows: [],
};

function CashLedger() {
  const [loading, setLoading] = useState(false);
  const [dataTable, setDataTable] = useState(tableData);
  const [query, setQuery] = useState({ sortBy: "createdAt", sortType: "desc" });
  const [checkCreate, setCheckCreate] = useState(true);
  const [paginationData, setPaginationData] = useState({
    page: 1,
    count: 0,
    size: 10,
  });

  useEffect(() => {
    fetchData();
  }, [query, paginationData.page]);

  const fetchData = async () => {
    try {
      setLoading(true);

      const response = await SecuritiesPortfolioService.getPaginate({
        ...query,
        page: paginationData.page,
        size: paginationData.size,
      });

      const { items, checkCreate: createPerm, paginate } = response.data || response;
      setCheckCreate(createPerm ? false : true);
      setPaginationData((prev) => ({
        ...prev,
        count: paginate?.count || 0,
        size: paginate?.size || 10,
      }));

      setDataTable((prev) => ({
        ...prev,
        rows: renderData(items || [], setDataTable),
      }));

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Lỗi lấy dữ liệu Sổ Chi Tiết Đầu Tư Chứng Khoán (S45-DN):", error);
      setDataTable((prev) => ({ ...prev, rows: [] }));
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox my={3}>
        <Card style={{ height: "100%" }}>
          <DataTable
            checkCreate={checkCreate}
            query={query}
            table={dataTable}
            loading={loading}
            setQuery={setQuery}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
          />
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}

export default CashLedger;
